<button (click)="emit()">{{displayText()}}</button>
